module.exports = __webpack_public_path__ + "triangleChimera.jpg?32952eff1e532bcabd075acfacb40e3a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/triangleChimera.jpg
// module id = 27
// module chunks = 0